<template>
<ViskaseCard>
    <template v-slot:title>
    </template>
    <template v-slot:default>
        <div class="row justify-content-center align-items-center p-1">
            <div class="col-12 text-center px-4">
                <div v-html="title" class="h3">
                </div>
            </div>
            <div class="col-12 col-sm-4" v-for="(solution, index) in activeSolutions" :key="index">
                <ViskaseTile>
                    <template v-slot:content>
                        <div class="p-0" @click="gotoSolution(solution)">
                            <button type="button" class="btn btn-viskase">
                                {{ solution.alias }}
                            </button>
                        </div>
                    </template>
                </ViskaseTile>
            </div>
        </div>
    </template>
</ViskaseCard>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import ViskaseCard from "@/components/core/ViskaseCard.vue";
import ViskaseTile from "@/components/core/ViskaseTile.vue";
export default {
  name: "Cases",
  components: {
    ViskaseCard,
    ViskaseTile,
  },
  data() {
    return {
      activeSolutions: [],
    };
  },
  mounted() {
    this.fetchSolutions()
      .then(() => {
        this.fetchProductSolutions().then(() => {
          var solutions = this.solutions;
          var selectedProductId = this.selectedProduct.id;
          var productSolutions = this.productSolutions;
          var selectedProductSolutions = productSolutions.find(
            (x) => x.productId === selectedProductId
          ) || {
            solutions: [],
          };

          this.activeSolutions = selectedProductSolutions.solutions.map((x) =>
            solutions.find((z) => z.id === x)
          );
        });
      })
      .then(() => {
        this.fetchCasings().then(() => this.fetchCasingLinks());
      });
  },
  methods: {
    ...mapActions([
      "fetchSolutions",
      "fetchProductSolutions",
      "fetchCasings",
      "fetchSolutionCasings",
      "fetchCasingLinks",
    ]),
    ...mapMutations([
      "setSelectedSolution",
      "setSelectedCasing",
      "setActiveCasings",
      "setSelectedLinks",
    ]),
    gotoSolution(solution) {
      this.setSelectedSolution(solution);

      this.fetchSolutionCasings()
        .then(() => {
          var activeCasings = [];
          var casings = this.casings;
          var selectedSolutionId = this.selectedSolution.id;
          var selectedProductId = this.selectedProduct.id;
          var solutionCasings = this.solutionCasings;
          var selectedSolutionCasings = solutionCasings.find(
            (x) => x.solutionId === selectedSolutionId
          ) || {
            casings: [],
          };

          if (selectedSolutionCasings.casings) {
            activeCasings = (selectedSolutionCasings.casings || []).map((x) => {
              var casing = {
                ...casings.find((z) => z.id === x),
                ...selectedSolutionCasings,
              };
              return casing;
            });
            this.setActiveCasings(activeCasings);
          }

          //Jesli mamy redirects tzn ze mamy na cos przekierowac
          if (selectedSolutionCasings.redirects) {
            var redirects = selectedSolutionCasings.redirects || [];
            var productSolutionRedirects = redirects.find(
              (x) => x.productId === selectedProductId
            ) || {
              productId: selectedProductId,
              solutions: [],
              casings: [],
            };

            //Jezeli mamy przekierowania na solutions to wyszukujemy casings powiazane ze wskazanymi solutions
            if (
              productSolutionRedirects.solutions &&
              productSolutionRedirects.solutions.length > 0
            ) {
              //Najpierw wyszukujemy solutions a pozniej scalamy casingi ze wszystkich solutions
              var productRedirectsSolutions = productSolutionRedirects.solutions
                .map((x) => {
                  var redirectSolutionCasings = solutionCasings.find(
                    (z) => z.solutionId === x
                  ) || {
                    casings: [],
                  };
                  return redirectSolutionCasings.casings;
                })
                .flatMap((x) => x);

              activeCasings = productRedirectsSolutions.map((x) => {
                var casing = {
                  ...casings.find((z) => z.id === x),
                  ...selectedSolutionCasings,
                };
                return casing;
              });

              this.setActiveCasings(activeCasings);
            }

            //Jezeli mamy przekierowanie na casings to po prostu wyszukujemy casings
            if (
              productSolutionRedirects.casings &&
              productSolutionRedirects.casings.length > 0
            ) {
              var productRedirectsCasings =
                productSolutionRedirects.casings || [];

              activeCasings = productRedirectsCasings.map((x) => {
                var casing = {
                  ...casings.find((z) => z.id === x),
                  ...selectedSolutionCasings,
                };
                return casing;
              });
            }
          }
          if (activeCasings.length === 1) {
            var activeCasing = activeCasings[0];
            this.setSelectedCasing(activeCasing);
            return;
          }

          this.setSelectedCasing({});
        })
        .then(() => {
          var selectedCasingId = this.selectedCasing.id;
          if (selectedCasingId) {
            this.$router.push({
              name: "casings",
              params: {
                language: this.$route.params.language,
                product: this.$route.params.product,
                solution: solution.name,
              },
            });
          } else {
            this.$router.push({
              name: "group-casings",
              params: {
                language: this.$route.params.language,
                product: this.$route.params.product,
                solution: solution.name,
              },
            });
          }
        });
    },
  },
  computed: {
    ...mapState([
      "solutions",
      "selectedSolution",
      "selectedProduct",
      "selectedCasing",
      "cards",
      "productSolutions",
      "solutionCasings",
      "casings",
      "casingLinks",
      "activeCasings",
      "selectedLinks",
    ]),
    title() {
      return this.cards.solutions.title.replace(
        /{selectedProduct}/g,
        "<span class='casing-title'>" +
          (
            this.selectedProduct || {
              title: "",
            }
          ).title.replace(/ /g, "&nbsp;") +
          "</span>"
      );
    },
  },
};
</script> 

<style scoped></style>
